import { createStyles, makeStyles } from '@material-ui/styles';
import sicrediStyle from 'assets/styles/default.scss';
export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '100%',
      borderRadius: '8px',
      border: '1px solid',
      borderColor: sicrediStyle.secondarySicrediLight,
      // boxShadow: '0px 0px 3px 0px #00000060',
    },
    title: {
      fontWeight: 700,
    },
    nomeDocumento: {
      fontSize: 16,
      fontWeight: 600,
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '12px 0 0 0',
      height: 52,
    },
    textAreaLabel: {
      // transform: 'translate(15px, 7px) scale(1)',
    },
    description: {},
    addButton: {},
  })
);
